<template>
  <div>
    <h4 class="marginl10" v-if="$route.path == '/branch/starindex/Homestart1'">
      已完成救援案件管理
    </h4>
    <h4 class="marginl10" v-if="$route.path == '/branch/starindex/Homestart2'">
      未启动救援案件管理
    </h4>
    <h4 class="marginl10" v-if="$route.path == '/branch/starindex/Homestart'">
      已启动救援案件管理
    </h4>
    
    <!-- ========== 优化后的筛选区域 ========== -->
    <div class="filter-container">
      <!-- 第一行：时间筛选和保险公司 -->
      <div class="filter-row">
        <div class="filter-item">
          <label class="filter-label">起始时间：</label>
          <el-date-picker
            @change="sttime()"
            v-model="st_time"
            align="right"
            type="date"
            placeholder="选择日期"
            :picker-options="pickerOptions1"
            class="filter-date-picker">
          </el-date-picker>
        </div>
        <div class="filter-item">
          <label class="filter-label">结束时间：</label>
          <el-date-picker
            @change="entime()"
            v-model="en_time"
            align="right"
            type="date"
            placeholder="选择日期"
            :picker-options="pickerOptions1"
            class="filter-date-picker">
          </el-date-picker>
        </div>
        <div class="filter-item">
          <label class="filter-label">保险公司筛选：</label>
          <el-select
            v-model="insuranceCompanyId"
            @change="suoshuFun"
            placeholder="请选择保险公司"
            filterable
            class="filter-select">
            <el-option
              v-if="item.insti.name"
              v-for="item in companies"
              :key="item.id"
              :label="item.insti.name"
              :value="item.insti.id">
            </el-option>
          </el-select>
        </div>
        <div class="filter-item" v-if="companies1.length != 0 && insuranceCompanyId != ''">
          <label class="filter-label">保险公司子公司：</label>
          <el-select
            v-model="subRegulatorId"
            placeholder="请选择保险公司"
            filterable
            class="filter-select">
            <el-option
              v-for="item in companies1"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </div>
      </div>

      <!-- 第二行：查询字段 -->
      <div class="filter-row">
        <div class="filter-item">
          <label class="filter-label">报案人查询：</label>
          <el-input
            v-model="reportUser"
            placeholder="请输入内容"
            class="filter-input">
          </el-input>
        </div>
        <div class="filter-item">
          <label class="filter-label">案件号查询：</label>
          <el-input
            v-model="caseNo"
            placeholder="请输入内容"
            class="filter-input">
          </el-input>
        </div>
        <div class="filter-item">
          <label class="filter-label">订单号查询：</label>
          <el-input
            v-model="jtOrderId"
            placeholder="请输入内容"
            class="filter-input">
          </el-input>
        </div>
        <div class="filter-item">
          <label class="filter-label">手机号查询：</label>
          <el-input
            v-model="victimMobile"
            placeholder="请输入内容"
            class="filter-input">
          </el-input>
        </div>
      </div>

      <!-- 第三行：保险相关字段 -->
      <div class="filter-row">
        <div class="filter-item">
          <label class="filter-label">保单号：</label>
          <el-input
            v-model="victimPolicyNo"
            placeholder="请输入内容"
            class="filter-input">
          </el-input>
        </div>
        <div class="filter-item">
          <label class="filter-label">被保险人：</label>
          <el-input
            v-model="victimUser"
            placeholder="请输入内容"
            class="filter-input">
          </el-input>
        </div>
        <div class="filter-item">
          <label class="filter-label">服务类型筛选：</label>
          <el-select v-model="accidentType" placeholder="请选择" class="filter-select">
            <el-option
              v-for="item in accidentTypes"
              :key="item"
              :label="item"
              :value="item">
            </el-option>
          </el-select>
        </div>
        <div class="filter-item">
          <label class="filter-label">证件信息：</label>
          <el-input
            v-model="victimNational"
            placeholder="请输入内容"
            class="filter-input">
          </el-input>
        </div>
        <div class="filter-item">
          <label class="filter-label">供应商筛选：</label>
          <el-select
            v-model="instiIds"
            placeholder="救援公司名称"
            filterable
            clearable
            class="filter-select">
            <el-option
              v-for="company in assistInstituteOptions"
              :key="company.id"
              :label="company.name"
              :value="company.id">
            </el-option>
          </el-select>
        </div>
      </div>

      <!-- 按钮区域 -->
      <div class="button-row">
        <div class="button-group">
          <el-button type="primary" plain @click="filt()" class="filter-btn">
            查询
          </el-button>
          <el-button type="warning" plain @click="Reset()" class="reset-btn">
            重置
          </el-button>
          <el-button type="success" @click="caseexport()" class="export-btn">
            导出结果数据
          </el-button>
          <span class="export-records-link" @click="Exportrecords()">
            导出记录
          </span>
        </div>
      </div>
    </div>
    <!-- ========== 优化后的筛选区域结束 ========== -->

    <div class="form_box">
      <el-table empty-text="暂无数据" :data="tableData" border>
        <el-table-column  label="案件编号" min-width="80">
          <template slot-scope="scope">
            {{scope.row.casenumber}}({{scope.row.regulatorId}})
          </template>
        </el-table-column>
        <el-table-column prop="address" label="发生地点" min-width="100%">
        </el-table-column>
        <el-table-column prop="username" label="报案人" min-width="50%">
        </el-table-column>
        
        <el-table-column prop="phone" label="用户手机号" min-width="70%">
        </el-table-column>
        <el-table-column prop="reportUser" label="被保险人" min-width="50%">
        </el-table-column>
        <el-table-column prop="papers" label="证件信息" min-width="70%">
        </el-table-column>
        <el-table-column prop="jtOrderId" label="订单号" min-width="70%">
        </el-table-column>
        <el-table-column prop="sex" label="性别" min-width="40%">
        </el-table-column>
        <el-table-column prop="reportTs" label="报案时间" min-width="90%">
        </el-table-column>
        <el-table-column prop="accidentType" label="服务类型" min-width="90%">
        </el-table-column>
        <el-table-column
          prop="insurancePolicyNo"
          label="保单号"
          min-width="90%"
        >
        </el-table-column>
        <el-table-column prop="plan" label="当前进度" min-width="80%">
        </el-table-column>
        <el-table-column
          prop="subRegulatorIdname"
          label="保险公司子公司"
          min-width="80%"
        >
        </el-table-column>
        <el-table-column prop="op" label="操作" min-width="90%">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="topar(scope.row.initialCaseId,scope.row)"
              >案件详情</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        style="margin-top: 15px; float: right"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage4"
        :page-sizes="[10,20,30,40,50]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
      <el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
        <span>确认关闭？</span>
        <textarea
          placeholder="请输入关闭原因"
          v-model="closeTxt"
          class="closeTxt"
        ></textarea>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button
            type="primary"
            @click="
              dialogVisible = false;
              closeCase(closeId);
            "
            >确 定</el-button
          >
        </span>
      </el-dialog>
    </div>
    <!-- 弹窗 -->
    <el-dialog
      title="确认完成案件"
      center
      :visible.sync="dialogFormVisible"
      width="800px"
    >
      <div class="popBox">
        <p style="margin-bottom: 15px">救援费用:</p>
        <ul>
          <li>
            <span>救援费用</span>
            <el-input type="text" v-model="rescueFee"></el-input>
            <span>RMB</span>
          </li>
          <li>
            <span>医疗费用</span>
            <el-input type="text" v-model="medicFee"></el-input>
            <span>RMB</span>
          </li>
          <li>
            <span>其他费用</span>
            <el-input type="text" v-model="otherFee"></el-input>
            <span>RMB</span>
          </li>
        </ul>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="sureFun()">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 添加 -->
    <el-dialog
      title="修改协调人"
      :visible.sync="showcooperaterDialogVisible"
      center
      top="1vh"
      width="1000px"
      @close="toggleSelection()"
    >
      <span
        class="contactAddStyle"
        @click="addContacterDialogVisible = true"
      ></span>
      <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
        <el-tab-pane label="修改协调人" name="second">
          <el-table
            empty-text="暂无数据"
            :data="cooperaterData"
            class="mgt15"
            border
            @selection-change="handleSelectionChange"
            ref="multipleTable"
          >
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column
              prop="name"
              label="姓名"
              min-width="30"
            ></el-table-column>
            <el-table-column
              prop="mobileNo"
              label="手机号"
              min-width="30"
            ></el-table-column>
            <el-table-column
              prop="nationalId"
              label="证件号码"
              min-width="30"
            ></el-table-column>
          </el-table>
          <div style="text-align: center; margin-top: 10px">
            <el-button type="primary" @click="diffDomestic()">确定</el-button>
            <el-button
              @click="
                toggleSelection();
                showcooperaterDialogVisible = false;
              "
              >取消</el-button
            >
          </div>
        </el-tab-pane>
        <el-tab-pane label="非公司隶属的协调人" name="first">
          <el-table
            empty-text="暂无数据"
            :data="cooperaterData1"
            class="mgt15"
            border
            @selection-change="handleSelectionChange1"
            ref="multipleTable1"
          >
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column
              prop="name"
              label="姓名"
              min-width="30"
            ></el-table-column>
            <el-table-column
              prop="mobileNo"
              label="手机号"
              min-width="30"
            ></el-table-column>
          </el-table>
          <div style="text-align: center; margin-top: 10px">
            <el-button type="primary" @click="diffNormalUser()">确定</el-button>
            <el-button
              @click="
                toggleSelection1();
                showcooperaterDialogVisible = false;
              "
              >取消</el-button
            >
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
    <!-- 添加新注册的协调人 -->
    <el-dialog
      title="添加新协调人"
      center
      :visible.sync="addContacterDialogVisible"
      width="500px"
    >
      <div>
        <div id="">
          姓&nbsp;&nbsp;&nbsp;&nbsp;名：<el-input
            v-model="victimName"
            placeholder="请输入姓名"
            style="width: 300px"
          ></el-input>
        </div>
        <div style="margin-top: 10px">
          手机号：<el-input
            v-model="nationalMobile"
            placeholder="请输入姓名"
            style="width: 300px"
          ></el-input>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addContacterDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="newDJXid()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import qs from "qs";
import {
  listSubRegulators,
  userlist_regulator,
  getfinishSureCase,
  listSubUser,
  diffDomestic,
  listDomestic,
  removeDomestic,
  closeOrdinaryCase,
  listNormalUser,
  diffNormalUser,
  creatBasic,
  joinCoord,
  export_caseManage_List
} from "@/views/axios/api.js";
import constants from "@/util/constants.js";
import instiIdsFilterMixin from "@/components/cmd_center/star/mixins/instiIdsFilterMixin.js";
export default {
  mixins: [instiIdsFilterMixin],
  data() {
    return {
      start: 0,
      count: 10,
      total: 0,
      currentPage4: 1,
      victimUser: "",
      victimMobile: "",
      caseNo: "",
      jtOrderId:"",
      victimPolicyNo: "",
      victimNational: "",
      accidentTypes: [
        "疏通马桶服务",
        "开锁服务",
        "油烟机清洗",
        "油烟机拆洗",
        "保洁2小时",
        "保洁4小时",
        "擦玻璃小户型（100平米下）",
        "擦玻璃大户型（100-150平米）",
      ],
      accidentType: "",
      reportUser: "",
      st_time: "",
      en_time: "",
      subRegulatorId: "",
      companies1: [],
      companies: [],
      insuranceCompanyId: "",
      closeId: "",
      closeTxt: "",
      obj: [],
      victimList: [],
      dialogVisible: false,
      tableData: [],
      token: JSON.parse(window.localStorage.getItem("data")).data,
      dialogFormVisible: false,
      totalFee: "",
      rescueFee: "",
      medicFee: "",
      otherFee: 0,
      caseId: "",
      userType: JSON.parse(window.localStorage.getItem("insti")).type,
      showcooperaterDialogVisible: false, //添加
      cooperaterData: [], //所有联系人
      cooperaterData1: [], //所有联系人
      cooperaterDataList: [], //当前案件未修改之前的记录
      cooperaterDataListCheck: [], //当前案件修改之后
      dialogFormVisible1: false,
      statusObj: ["在保", "无保", "在保", "旅责险"],
      activeName: "second",
      tabBtn: true,
      ruserDataListCheck: [],
      addContacterDialogVisible: false,
      victimName: "",
      nationalMobile: "",
    };
  },
  computed:{ //这里是监听自定义数组的变化 因为有一个计时器每秒都会减去数组中字段的时间 所以 数组是每秒更新的
  
    languageIndex(){
				return this.$store.state.language
			}
  },
  methods: {
    Exportrecords() {
        this.$router.push({
					name:'Exportrecords',
          query: {
                typeId: 800
              },
				})
      },
    handleSizeChange(val) {
      this.count = val;
      this.getData();
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.start = (val - 1) * this.count;
      // this.start = val * 10
      this.getData();
      console.log(`当前页: ${val}`);
    },
    caseexport() {
       if(this.st_time == null) {
        this.st_time = ''
       }
       if(this.en_time == '' || this.en_time == null ) {
        this.en_time =''
       }else{
        this.en_time = this.en_time + 24 * 60 * 60 * 1000 - 1
       }
       var statustxt = ''
       statustxt =
          statustxt +
          `&status=190`;
       var obj = {
        token:JSON.parse(window.localStorage.getItem("data")).data,
        incidentType:800,
        startTs:this.st_time,
        endTs:this.en_time,
        regulatorId:this.insuranceCompanyId,
        subRegulatorId:this.subRegulatorId,
        reportUser:this.reportUser,
        accidentType:this.accidentType,
        victimUser:this.victimUser,
        victimPolicyNo:this.victimPolicyNo,
        victimNational:this.victimNational,
        reporterContact:this.victimMobile,
        caseNo:this.caseNo,
        jtOrderId:this.jtOrderId,
        instiIds:this.instiIds,
        statustxt:statustxt
       }
  export_caseManage_List(obj).then((res)=>{
    if(res.data.code == 0) {
            this.$message({
                showClose: true,
                message: "请去导出记录中下载",
                type: "success",
              });
          }

  })
      // window.location.href = `${SEVSRS}/rescue/case/export_caseManage_List?token=${
      //   JSON.parse(window.localStorage.getItem("data")).data
      // }&incidentType=800&status=190&startTs=${this.st_time}&endTs=${
      //   this.en_time
      // }&regulatorId=${this.insuranceCompanyId}&subRegulatorId=${
      //   this.subRegulatorId
      // }&reportUser=${this.reportUser}&accidentType=${
      //   this.accidentType
      // }&victimUser=${this.victimUser}&victimPolicyNo=${
      //   this.victimPolicyNo
      // }&victimNational=${this.victimNational}&reporterContact=${
      //   this.victimMobile
      // }&caseNo=${this.caseNo}`;
    },
    Reset() {
      (this.accidentType = ""),
        (this.reportUser = ""),
        (this.st_time = ""),
        (this.en_time = ""),
        (this.subRegulatorId = ""),
        (this.insuranceCompanyId = ""),
        (this.victimUser = ""),
        (this.victimPolicyNo = ""),
        (this.victimNational = ""),
        (this.victimMobile = ""),
        (this.caseNo = ""),
        (this.jtOrderId = ""),
        (this.instiIds = "");
      this.getData();
    },
    suoshuFun() {
      userlist_regulator({
        token: JSON.parse(window.localStorage.getItem("data")).data,
        regulatorId: this.insuranceCompanyId,
      }).then((res) => {
        this.companies1 = res.data.obj;
        console.log(res);
      });
    },
    setTxt(str, status) {
      if (constants.setTxt(str, status)) {
        return constants.setTxt(str, status);
      } else {
        return str;
      }
    },
    setTime(str) {
      return constants.time(str);
    },
    handleClick(tab, event) {
      console.log(tab);
    },
    topathDetail(index) {
      if (this.$route.name == "ComAwait1") {
        this.$router.push({
          name: "helpStart",
          params: {
            token: this.token,
          },
          query: {
            typeId: 800,
            caseid: this.obj[index].id,
            refused: 1,
          },
        });
      } else {
        this.$router.push({
          name: "helpStart",
          params: {
            token: this.token,
          },
          query: {
            typeId: 800,
            caseid: this.obj[index].id,
          },
        });
      }
    },
    topar(id,item) {
      var url = "";
      if (SEVSRS == "http://api.test.dajiuxing.com.cn/") {
        url = "http://www.test.dajiuxing.com.cn/";
      } else {
        url = "https://www.dajiuxing.com.cn/";
      }
        window.open(url + "djxwork/#/cmd_center/caseDetails?caseid=" + id +'&subRegulatorIdname=' + item.subRegulatorIdname);
      //  http://api.test.dajiuxing.com.cn/djxwork/#/cmd_center/caseDetails?caseid=1319
      //  http://www.test.dajiuxing.com.cn/djxwork/#/cmd_center/caseDetails?caseid=1291
      // this.$router.push({
      //   path: '/cmd_center/caseDetails',
      //   query: {
      //     caseid: id
      //   },
      // });
      return;
      let that = this;
      this.$router.push({
        path: "par",
        name: "ComPar",
        params: {
          token: that.token,
          obj: that.obj,
          victimList: that.victimList,
          index,
        },
        query: {
          typeId: this.typeId,
          caseid: this.obj[index].id,
          backto: 0,
        },
      });
    },

    listSubUser() {
      var data = {
        token: this.token,
        start: 0,
        count: 100,
        all: 1,
      };
      listSubUser(data)
        .then((res) => {
          console.log(res);
          this.cooperaterData = res.data.obj;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleSelectionChange(val) {
      this.cooperaterDataListCheck = val;
    },
    handleSelectionChange1(val) {
      this.ruserDataListCheck = val;
    },
    removeDomestic(id) {
      var data = {
        token: this.token,
      };
      removeDomestic(data, id)
        .then((res) => {
          console.log(res);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    toUrl(url) {
      window.open(url);
    },
    filt() {
      this.start = 0;
      this.getData(
        this.st_time,
        this.en_time,
        this.reportUser,
        this.accidentType,
        this.insuranceCompanyId,
        this.subRegulatorId
      );
    },
    sttime() {
      this.st_time = this.st_time * 1;
      // this.getData(this.st_time, 0);
      // console.log(this.st_time);
    },
    entime() {
      this.en_time = this.en_time * 1;
      // this.getData(0, this.en_time);
    },
    getData(
      st,
      et,
      reportUser,
      accidentType,
      insuranceCompanyId,
      subRegulatorId
    ) {
      userlist_regulator({
        token: JSON.parse(window.localStorage.getItem("data")).data,
        regulatorId: this.insuranceCompanyId,
      }).then((res) => {
        this.companies1 = res.data.obj;
        console.log(res);
      });
      listSubRegulators({
        token: JSON.parse(window.localStorage.getItem("data")).data,
      }).then((res) => {
        this.companies = res.data.obj;
        console.log(res);
      });
      this.tableData = [];
      let that = this;
      let n = 0;
      let sex = "";
      let isshow = false;
      let stTime = st || this.st_time;
      let enTime = et || this.en_time;
      let plan = "";
      let list = [];
      let tl = "";
      // 分页 getData() 无参时形参为 undefined，须用 this.* 判断
      if (
        stTime ||
        enTime ||
        this.reportUser ||
        this.accidentType ||
        this.insuranceCompanyId ||
        this.subRegulatorId ||
        this.victimUser ||
        this.victimNational ||
        this.victimPolicyNo ||
        this.victimMobile ||
        this.caseNo||
        this.jtOrderId ||
        this.hasInstiIdsFilter()
      ) {
          if(stTime == null) {
        stTime = ''
       }
       if(enTime == '' || enTime == null ) {
        enTime =''
       }else{
        enTime = enTime + 24 * 60 * 60 * 1000 - 1
       }
        tl =
          tl +
          `&startTs=${stTime}&endTs=${enTime}&reportUser=${this.reportUser}&accidentType=${this.accidentType}&regulatorId=${this.insuranceCompanyId}&subRegulatorId=${this.subRegulatorId}&victimUser=${this.victimUser}&victimNational=${this.victimNational}&victimPolicyNo=${this.victimPolicyNo}&reporterContact=${this.victimMobile}&caseNo=${this.caseNo}&jtOrderId=${this.jtOrderId}`;
        tl = this.appendInstiIdsQuery(tl);
      } else if (this.hasInstiIdsFilter()) {
        tl = this.appendInstiIdsQuery(tl);
      }

      let nl = 0;

      fetch(constants.domain + "rescue/case/list_case", {
        method: "POST",
        body:
          `token=${this.token}&typeId=${this.$route.query.typeId}&status=190&start=${this.start}&count=${this.count}` +
          tl,
        mode: "cors",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      })
        .then(function (res) {
          // that.tableData = res.data.obj
          console.log(res);
          return res.json();
        })
        .then(function (data) {
          // that.tableData = data.obj
          that.total = data.total;
          console.log(data.obj);
          if (data.obj) {
            data.obj.map((v, i) => {
              console.log(v.obj.caseNo);
              async function getout(state) {
                that.axios
                  .post(
                    constants.domain + "rescue/bidding/list_bidding",
                    qs.stringify({
                      token: that.token,
                      caseId: v.obj.id,
                    })
                  )
                  .then((res) => {
                    list = res.data.obj;

                    if (
                      v.victimList[0].obj.insurancePolicyNo &&
                      v.victimList[0].obj.insurancePolicyNo != ""
                    ) {
                      isshow = true;
                    } else {
                      isshow = false;
                    }

                    var pt = constants.pt2txt2(state);
                    var address = "";
                    if (v.generalLocation) {
                      if (!constants.setTxt(v.generalLocation.addr, "zh")) {
                        address = v.generalLocation.addr;
                      } else {
                        address =
                          that.languageIndex == 0
                            ? constants.setTxt(v.generalLocation.addr, "zh")
                            : constants.setTxt(v.generalLocation.addr, "en");
                      }
                    }
            
                    if(v.helpOrder == null) {
                      v.jtOrderId = ''
                      }else {
                        v.jtOrderId = v.helpOrder.id
                      }
                    that.tableData.push({
                      state: v.obj.caseState,
                      caseId: v.obj.id,
                      initialCaseId: v.obj.initialCaseId,
                      stateText3: v.obj.stateText3 || "无",
                      number: i + 1, //序号
                      casenumber: v.obj.caseNo, //案件编号
                      jtOrderId:v.jtOrderId,
                      address, //地址
                      username: v.victimList[0].obj.victimName, //用户信息
                      papers: v.victimList[0].obj.idNo, //身份证号
                      phone: v.obj.reporterContact, //联系方式
                      sex: sex, //性别
                      time: constants.time(v.obj.incidentTs), //出险时间
                      reportTs: constants.time(v.obj.reportTs),
                      plan: pt.phase, //进度
                      node: pt.node, //节点
                      isshow: isshow,
                      open: v.obj.caseSrc,
                      get_time: constants.time(v.obj.incidentTs),
                      op: "查看并操作",
                      insuranceUrl: v.victimList[0].obj.insurancePaper, //用户保险详情链接
                      w: v.obj.updateAt,
                    });
                    nl--;
                    // if (nl == 0) {
                    // 	console.log('sortting!!');
                    // 	that.tableData.sort(sortcase);
                    // }
                  });
              }
              if (v.victimList[0].obj.gender == "1") {
                sex = "男";
              } else if (v.victimList[0].obj.gender == "2") {
                sex = "女";
              } else {
                sex = "-";
              }
              if (
                v.victimList[0].obj.insurancePolicyNo &&
                v.victimList[0].obj.insurancePolicyNo != ""
              ) {
                isshow = true;
              } else {
                isshow = false;
              }
              var pt = constants.pt2txt2(v.obj.caseState);
              if (
                v.obj.caseState == 140 ||
                v.obj.caseState == 150 ||
                v.obj.caseState == 160
              ) {
                nl++;
                getout(v.obj.caseState);
              } else {
                var address = "";
                if (v.generalLocation) {
                  if (!constants.setTxt(v.generalLocation.addr, "zh")) {
                    address = v.generalLocation.addr;
                  } else {
                    address =
                      that.languageIndex == 0
                        ? constants.setTxt(v.generalLocation.addr, "zh")
                        : constants.setTxt(v.generalLocation.addr, "en");
                  }
                }
                if(v.helpOrder == null) {
                      v.jtOrderId = ''
                      }else {
                        v.jtOrderId = v.helpOrder.id
                      }
                that.tableData.push({
                  state: v.obj.caseState,
                  caseId: v.obj.id,
                  initialCaseId: v.obj.initialCaseId,
                  stateText3: v.obj.stateText3 || "无",
                  number: i + 1, //序号
                  casenumber: v.obj.caseNo, //案件编号
                  address, //地址
                  jtOrderId:v.jtOrderId,
                  username: v.obj.reportUser, //用户信息
                  reportUser: v.victimList[0].obj.victimName, //用户信息
                  papers: v.victimList[0].obj.idNo, //身份证号
                  phone: v.obj.reporterContact, //联系方式
                  sex: sex, //性别
                  time: constants.time(v.obj.incidentTs), //出险时间
                  reportTs: constants.time(v.obj.reportTs),
                  plan: pt.phase, //进度
                  node: pt.node, //节点
                  isshow: isshow,
                  open: v.obj.caseSrc,
                  get_time: constants.time(v.obj.incidentTs),
                  op: "查看并操作",
                  insuranceUrl: v.victimList[0].obj.insurancePaper, //用户保险详情链接
                  w: v.obj.updateAt,
                  subRegulatorIdname: v.obj.subRegulatorId,
                  regulatorId: v.obj.regulatorId,
                  insurancePolicyNo: v.victimList[0].obj.insurancePolicyNo,
                  accidentType: v.obj.accidentType,
                });
              }
              for (var i = 0; i < that.tableData.length; i++) {
                for (var j = 0; j < that.companies1.length; j++) {
                  if (
                    that.tableData[i].subRegulatorIdname ==
                    that.companies1[j].id
                  ) {
                    that.tableData[i].subRegulatorIdname =
                      that.companies1[j].name;
                  }
                }
              }
              console.log(v);
              that.caseId = v.obj.id;

              that.obj.push(v.obj);
              that.victimList.push(v.victimList[0]);
            });
          }
        });
    },
    // getData() {
    //   var status='status=100';

    //   var data = {
    //     token: this.token,
    //     typeId: 800
    //   }
    //   xingshiGong(data,status)
    //     .then(res => {
    //       console.log(res);
    //       this.listSubUser()
    //       this.tableData=res.data.obj
    //     })
    //     .catch(err => {
    //       console.log(err);
    //     })
    // },
    closeCase(caseId) {
      console.log(this.closeId);
      var data = {
        token: this.token,
        caseId,
      };
      closeOrdinaryCase(data)
        .then((res) => {
          if (res.data.code == 0) {
            this.$message.success("案件已关闭");
            this.getData();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    listDomestic(id) {
      var data = {
        token: this.token,
        start: 0,
        count: 100,
        caseId: id,
      };
      listDomestic(data)
        .then((res) => {
          this.cooperaterDataList = res.data.obj;
          var cooperaterDataList = [];
          this.cooperaterDataList.forEach((item) => {
            this.cooperaterData.forEach((item1) => {
              if (item1.id == item.id) {
                cooperaterDataList.push(item1);
              }
            });
          });
          this.cooperaterDataList = cooperaterDataList;
          this.toggleSelection(cooperaterDataList);
        })
        .catch((err) => {
          console.log(err);
        });
      var data1 = {
        token: this.token,
        caseId: id,
      };
      listNormalUser(data1)
        .then((res) => {
          console.log(res);
          this.cooperaterData1 = res.data.obj;
          setTimeout(() => {
            this.toggleSelection1(this.cooperaterData1);
          }, 500);
        })
        .catch((err) => {
          console.log(err);
        });
    },

    diffDomestic() {
      var fids = "";
      this.cooperaterDataListCheck.forEach((item, index) => {
        fids += "fids=" + item.id + "&";
      });
      var oids = "";
      this.cooperaterDataList.forEach((item, index) => {
        if (index < this.cooperaterDataList.length - 1) {
          oids += "oids=" + item.id + "&";
        } else {
          oids += "oids=" + item.id;
        }
      });
      var data = {
        token: this.token,
        caseId: this.caseId,
      };
      diffDomestic(data, fids, oids)
        .then((res) => {
          if (res.data.code == 0) {
            this.showcooperaterDialogVisible = false;
            this.$message.success("添加成功");
            this.getData();
          }
          console.log(res);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    diffNormalUser() {
      var fids = "";
      this.ruserDataListCheck.forEach((item, index) => {
        if (index < this.ruserDataListCheck.length - 1) {
          fids += "fids=" + item.id + "&";
        } else {
          fids += "fids=" + item.id;
        }
      });
      var data = {
        token: this.token,
        caseId: this.caseId,
      };
      diffNormalUser(data, fids)
        .then((res) => {
          if (res.data.code == 0) {
            this.showcooperaterDialogVisible = false;
            this.$message.success("添加成功");
            this.getData();
          }
          console.log(res);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    tores(obj) {
      console.log(obj);
      this.caseId = obj.obj.id;
      this.dialogFormVisible = true;
      // this.totalFee=obj.obj.totalFee ;
      this.medicFee = obj.obj.medicFee || 0;
      this.otherFee = obj.obj.otherFee || 0;
      this.rescueFee = obj.obj.rescueFee || 0;
    },
    sureFun() {
      this.totalFee =
        Number(this.medicFee) + Number(this.otherFee) + Number(this.rescueFee);
      var data = {
        token: this.token,
        id: this.caseId,
        totalFee: this.totalFee,
        medicFee: this.medicFee,
        otherFee: this.otherFee,
        rescueFee: this.rescueFee,
      };
      getfinishSureCase(data)
        .then((res) => {
          console.log(res);
          if (res.data.code == 0) {
            this.$message.success("操作成功");
            this.getData();
            this.dialogFormVisible = false;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    toggleSelection(rows) {
      console.log(rows);
      if (rows) {
        rows.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    toggleSelection1(rows) {
      console.log(rows);
      if (rows) {
        rows.forEach((row) => {
          this.$refs.multipleTable1.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable1.clearSelection();
      }
    },
    //创建大救星账户
    newDJXid() {
      if (this.victimName == "") {
        return this.$message.error("出险人姓名不能为空");
      } else if (this.nationalMobile == "") {
        return this.$message.error("手机号不能为空");
      }
      var data = {
        token: this.token,
        name: this.victimName,
        nationalMobile: this.nationalMobile,
      };
      creatBasic(data)
        .then((res) => {
          console.log(res);
          if (res.data.code == 0) {
            this.$message.success("创建成功");
            this.addContacterDialogVisible = false;
            this.cooperaterData1.push(res.data.obj);
            this.victimName = "";
            this.nationalMobile = "";
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    openWork(caseId) {
      joinCoord({ token: this.token, caseId }, "")
        .then((res) => {
          console.log(res);
        })
        .catch((err) => {
          console.log(err);
        });
      this.$store.commit("caseIdFun", caseId);
      this.$store.commit("workBtnFun", true);
    },
  },
  mounted() {
    this.loadAssistInstituteOptions();
    this.getData();

    console.log(this.$route.path);
  },
};
</script>

<style scoped>
.popBox li {
  margin-bottom: 10px;
}
.popBox .el-input {
  width: 300px;
}
.contactAddStyle {
  position: absolute;
  top: 90px;
  right: 20px;
  cursor: pointer;
  z-index: 9;
}
.contactAddStyle::before {
  content: "+";
  color: #00abf9;
  width: 15px;
  height: 15px;
  display: inline-block;
  border-radius: 7.5px;
  text-align: center;
  line-height: 15px;
  font-size: 16px;
  margin-right: 5px;
  border: 1px solid #00abf9;
}

/* ========== 优化后的筛选区域样式 ========== */
.filter-container {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.filter-row {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  margin-bottom: 20px;
  align-items: end;
}

.filter-item {
  display: flex;
  flex-direction: column;
  min-width: 200px;
  flex: 1;
}

.filter-label {
  font-size: 14px;
  color: #606266;
  margin-bottom: 8px;
  font-weight: 500;
}

.filter-date-picker,
.filter-input,
.filter-select {
  width: 100% !important;
}

/* 专门针对日期选择器的宽度覆盖 */
.filter-date-picker .el-date-editor.el-input,
.filter-date-picker .el-date-editor.el-input__inner {
  width: 100% !important;
}

.button-row {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-top: 15px;
  border-top: 1px solid #e4e7ed;
  margin-top: 10px;
}

.button-group {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.filter-btn {
  background: #409eff;
  border-color: #409eff;
  color: white;
  padding: 10px 20px;
  border-radius: 4px;
  transition: all 0.3s ease;
}

.filter-btn:hover {
  background: #66b1ff;
  border-color: #66b1ff;
}

.reset-btn {
  background: #e6a23c;
  border-color: #e6a23c;
  color: white;
  padding: 10px 20px;
  border-radius: 4px;
  transition: all 0.3s ease;
}

.reset-btn:hover {
  background: #ebb563;
  border-color: #ebb563;
}

.export-btn {
  background: #67c23a;
  border-color: #67c23a;
  color: white;
  padding: 10px 20px;
  border-radius: 4px;
  transition: all 0.3s ease;
}

.export-btn:hover {
  background: #85ce61;
  border-color: #85ce61;
}

.export-records-link {
  color: #409eff;
  cursor: pointer;
  font-size: 14px;
  padding: 10px 15px;
  border-radius: 4px;
  transition: all 0.3s ease;
  white-space: nowrap;
}

.export-records-link:hover {
  background: #ecf5ff;
  color: #66b1ff;
  text-decoration: none;
}

/* 响应式设计 */
@media (max-width: 1400px) {
  .filter-row {
    gap: 15px;
  }
  
  .filter-item {
    min-width: 180px;
  }
}

@media (max-width: 1200px) {
  .filter-row {
    gap: 12px;
  }
  
  .filter-item {
    min-width: 160px;
  }
}

@media (max-width: 768px) {
  .filter-container {
    padding: 15px;
  }
  
  .filter-row {
    flex-direction: column;
    gap: 15px;
  }
  
  .filter-item {
    min-width: auto;
    width: 100%;
  }
  
  .button-row {
    justify-content: center;
  }
  
  .button-group {
    flex-direction: column;
    width: 100%;
    gap: 10px;
  }
  
  .filter-btn,
  .reset-btn,
  .export-btn {
    width: 100%;
    max-width: 200px;
  }
  
  .export-records-link {
    text-align: center;
    width: 100%;
    max-width: 200px;
  }
}

@media (max-width: 480px) {
  .filter-container {
    padding: 10px;
    margin-bottom: 15px;
  }
  
  .filter-label {
    font-size: 13px;
  }
  
  .filter-btn,
  .reset-btn,
  .export-btn {
    font-size: 14px;
    padding: 8px 16px;
  }
  
  .export-records-link {
    font-size: 13px;
    padding: 8px 12px;
  }
}
/* ========== 优化后的筛选区域样式结束 ========== */
</style>



// WEBPACK FOOTER //
// src/components/cmd_center/star/Homestart3.vue